import { serializeContactDetails } from './serializers'
import { ILenderLeadCapture, IContactDetails } from './types'

export function submitLenderContactForm(contactDetails: ILenderLeadCapture) {
  return window.axios({
    url: '/api/leads/lender-lead-capture/',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(contactDetails)
  })
}

/**
 * Sends the User's latest Inquiry Answer to the email provides
 * and creates a Lead associated with the Inquiry.
 */
export function emailInquiryAnswer(contactDetails: IContactDetails) {
  return window.axios({
    url: '/api/leads/send-lead-answer/',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(serializeContactDetails(contactDetails))
  })
}
